var _rect, _rect2, _rect3, _rect4, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _rect5, _rect6, _g, _path17, _rect7, _g2, _path18, _path19, _rect8, _g3, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _rect9, _rect10, _rect11, _rect12, _rect13, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOsmosisPoster(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 178,
    height: 230,
    viewBox: "0 0 178 230",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_676_244817)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 178,
    height: 230,
    rx: 5,
    fill: "#002F50"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: -191,
    y: 187.169,
    width: 559,
    height: 2.748,
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: -191,
    y: 189.917,
    width: 560,
    height: 36.3347,
    fill: "#004F9C"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 11.0498,
    y: 202.816,
    width: 96.9925,
    height: 12.1387,
    rx: 6.06937,
    fill: "#003B75"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M115.542 103.221C114.848 104.633 113.208 105.359 111.664 104.939L109.618 104.366C105.431 110.454 103.192 117.629 103.192 124.995V204.398C103.192 207.967 100.259 210.867 96.6509 210.867L22.6477 210.925C19.0199 210.925 16.0868 208.024 16.0868 204.456V97.5346C16.0868 94.9394 15.3149 92.4013 13.8484 90.2259C13.0765 88.5848 14.2922 86.7147 16.1254 86.7147H92.3477C100.587 86.7147 108.46 90.0542 114.134 95.9317C116.199 97.7827 116.777 100.76 115.542 103.221Z",
    fill: "#CCE0F3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6014 192.671L92.7439 192.614C96.3524 192.614 99.2855 189.713 99.2855 186.145V115.023C68.237 113.954 53.2572 100.081 18.0405 106.417V186.183C18.0405 189.77 20.9736 192.671 24.6014 192.671Z",
    fill: "#00AEEF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M47.9266 89.3455H20.8532C20.1392 89.3455 19.5603 89.9179 19.5603 90.624C19.5603 91.3301 20.1392 91.9026 20.8532 91.9026H47.9266C48.6406 91.9026 49.2195 91.3301 49.2195 90.624C49.2195 89.9179 48.6406 89.3455 47.9266 89.3455Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0405 110.191V202.524C18.0405 206.111 20.9736 209.012 24.6014 208.993L94.6975 208.936C98.306 208.936 101.239 206.035 101.239 202.466V121.256C101.239 120.607 103.875 107.891 105.504 106.808C75.0536 107.095 53.8361 115.287 18.0405 110.191Z",
    fill: "#33BEF2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5118 203.94H20.5388C19.9599 203.94 19.4968 203.482 19.4968 202.91C19.4968 202.338 19.9599 201.88 20.5388 201.88H29.5118C30.0907 201.88 30.5538 202.338 30.5538 202.91C30.5345 203.482 30.0714 203.94 29.5118 203.94Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5118 190.659H20.5388C19.9599 190.659 19.4968 190.201 19.4968 189.628C19.4968 189.056 19.9599 188.598 20.5388 188.598H29.5118C30.0907 188.598 30.5538 189.056 30.5538 189.628C30.5345 190.201 30.0714 190.659 29.5118 190.659Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5118 177.358H20.5388C19.9599 177.358 19.4968 176.9 19.4968 176.328C19.4968 175.755 19.9599 175.297 20.5388 175.297H29.5118C30.0907 175.297 30.5538 175.755 30.5538 176.328C30.5345 176.9 30.0714 177.358 29.5118 177.358Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5118 164.076H20.5388C19.9599 164.076 19.4968 163.618 19.4968 163.046C19.4968 162.473 19.9599 162.015 20.5388 162.015H29.5118C30.0907 162.015 30.5538 162.473 30.5538 163.046C30.5345 163.618 30.0714 164.076 29.5118 164.076Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5118 150.795H20.5388C19.9599 150.795 19.4968 150.337 19.4968 149.764C19.4968 149.192 19.9599 148.734 20.5388 148.734H29.5118C30.0907 148.734 30.5538 149.192 30.5538 149.764C30.5345 150.337 30.0714 150.795 29.5118 150.795Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5118 137.513H20.5388C19.9599 137.513 19.4968 137.055 19.4968 136.483C19.4968 135.91 19.9599 135.452 20.5388 135.452H29.5118C30.0907 135.452 30.5538 135.91 30.5538 136.483C30.5345 137.055 30.0714 137.513 29.5118 137.513Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5118 124.232H20.5388C19.9599 124.232 19.4968 123.774 19.4968 123.201C19.4968 122.629 19.9599 122.171 20.5388 122.171H29.5118C30.0907 122.171 30.5538 122.629 30.5538 123.201C30.5345 123.774 30.0714 124.232 29.5118 124.232Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5118 110.931H20.5388C19.9599 110.931 19.4968 110.473 19.4968 109.9C19.4968 109.328 19.9599 108.87 20.5388 108.87H29.5118C30.0907 108.87 30.5538 109.328 30.5538 109.9C30.5345 110.473 30.0714 110.931 29.5118 110.931Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5119 97.6491H20.5389C19.96 97.6491 19.4969 97.1911 19.4969 96.6187C19.4969 96.0462 19.96 95.5882 20.5389 95.5882H29.5119C30.0908 95.5882 30.5539 96.0462 30.5539 96.6187C30.5346 97.1911 30.0715 97.6491 29.5119 97.6491Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5196 203.941C19.9407 203.941 19.4776 203.483 19.4776 202.91V96.6379C19.4776 96.0654 19.9407 95.6074 20.5196 95.6074C21.0985 95.6074 21.5616 96.0654 21.5616 96.6379V202.929C21.5616 203.483 21.0985 203.941 20.5196 203.941Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M99.1166 195.471L99.1166 144.239C99.1166 143.529 98.5411 142.953 97.8314 142.953C97.1216 142.953 96.5461 143.529 96.5461 144.239L96.5461 195.471C96.5461 196.181 97.1216 196.757 97.8314 196.757C98.5411 196.757 99.1166 196.181 99.1166 195.471Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M99.1166 136.456L99.1166 130.353C99.1166 129.643 98.5411 129.067 97.8314 129.067C97.1216 129.067 96.5461 129.643 96.5461 130.353L96.5461 136.456C96.5461 137.166 97.1216 137.742 97.8314 137.742C98.5411 137.742 99.1166 137.166 99.1166 136.456Z",
    fill: "white"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 21.7004,
    height: 39.8475,
    rx: 10.8502,
    transform: "matrix(-0.338425 -0.940993 0.942114 -0.335294 121.661 159.937)",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_676_244817",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 120,
    y: 131,
    width: 34,
    height: 24
  }, _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 16.2753,
    height: 34.2874,
    rx: 8.13766,
    transform: "matrix(-0.338425 -0.940993 0.942114 -0.335294 123.362 156.452)",
    fill: "#99DFF9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_676_244817)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.2893,
    height: 37.0675,
    rx: 9.64464,
    transform: "matrix(-0.338425 -0.940993 0.942114 -0.335294 122.999 158.181)",
    fill: "#004660"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 18.0837,
    height: 34.2874,
    rx: 9.04185,
    transform: "matrix(-0.338425 -0.940993 0.942114 -0.335294 122.75 154.751)",
    fill: "#00688F"
  }))), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M114.333 155.165C113.927 155.932 112.8 155.849 112.506 155.031L110.295 148.885C110.013 148.1 110.759 147.338 111.551 147.601L115.879 149.038L116.568 150.953L114.333 155.165Z",
    fill: "#F7F7F7"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_676_244817",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 115,
    y: 147,
    width: 4,
    height: 5
  }, _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    width: 4.74697,
    height: 2.31211,
    rx: 1.15606,
    transform: "matrix(0.338425 0.940993 -0.942114 0.335294 117.599 146.987)",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_676_244817)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 4.74697,
    height: 2.31211,
    rx: 1.15606,
    transform: "matrix(0.338425 0.940993 -0.942114 0.335294 117.599 146.987)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.793 146.91C116.077 146.809 116.392 146.92 116.537 147.185C116.801 147.67 117.224 148.508 117.585 149.511C117.946 150.514 118.153 151.429 118.258 151.971C118.315 152.266 118.142 152.552 117.858 152.653C117.526 152.771 117.159 152.598 117.04 152.266L115.407 147.725C115.288 147.393 115.46 147.028 115.793 146.91Z",
    fill: "#BBBBBB"
  }))), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M111.75 155.591C111.227 156.093 110.357 155.889 110.112 155.206L108.364 150.346C108.129 149.693 108.614 149.008 109.307 149.011L115.879 149.038L116.568 150.953L111.75 155.591Z",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M161.799 138.298C162.606 138.683 163.473 137.902 163.171 137.062L160.679 130.134C160.39 129.328 159.287 129.232 158.865 129.976L156.558 134.048L157.318 136.16L161.799 138.298Z",
    fill: "#F7F7F7"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_676_244817",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 154,
    y: 132,
    width: 4,
    height: 7
  }, _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    width: 5.23804,
    height: 2.31211,
    rx: 1.15606,
    transform: "matrix(0.338425 0.940993 0.942114 -0.335294 153.874 133.415)",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_676_244817)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 5.23804,
    height: 2.31211,
    rx: 1.15606,
    transform: "matrix(0.338425 0.940993 0.942114 -0.335294 153.874 133.415)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.202 132.148C154.916 132.25 154.744 132.539 154.805 132.836C154.926 133.424 155.168 134.453 155.577 135.589C155.985 136.724 156.454 137.673 156.736 138.203C156.878 138.472 157.195 138.587 157.481 138.485C157.811 138.368 157.982 138.006 157.864 137.677L156.013 132.531C155.895 132.202 155.532 132.031 155.202 132.148Z",
    fill: "#BBBBBB"
  }))), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M164.058 136.969C164.797 137.057 165.369 136.341 165.117 135.642L163.124 130.099C162.885 129.434 162.049 129.218 161.519 129.685L156.558 134.048L157.318 136.16L164.058 136.969Z",
    fill: "white"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M99.3921 17.0469H102.894V36.0651H108.656V39.2347H99.3921V17.0469Z",
    fill: "white"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M97.1245 39.2347H93.5908L92.9859 35.2092H88.6882L88.0833 39.2347H84.8679L88.4335 17.0469H93.5589L97.1245 39.2347ZM89.1338 32.198H92.5084L90.8211 20.9773L89.1338 32.198Z",
    fill: "white"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M72.2769 22.372C72.2769 18.8219 74.1551 16.7933 77.5934 16.7933C81.0316 16.7933 82.9098 18.8219 82.9098 22.372V33.9096C82.9098 37.4597 81.0316 39.4883 77.5934 39.4883C74.1551 39.4883 72.2769 37.4597 72.2769 33.9096V22.372ZM75.7787 34.1315C75.7787 35.7164 76.4791 36.3186 77.5934 36.3186C78.7076 36.3186 79.408 35.7164 79.408 34.1315V22.1501C79.408 20.5653 78.7076 19.963 77.5934 19.963C76.4791 19.963 75.7787 20.5653 75.7787 22.1501V34.1315Z",
    fill: "white"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M64.7748 26.8729H69.6774V33.9096C69.6774 37.4597 67.8947 39.4883 64.4565 39.4883C61.0183 39.4883 59.2355 37.4597 59.2355 33.9096V22.372C59.2355 18.8219 61.0183 16.7933 64.4565 16.7933C67.8947 16.7933 69.6774 18.8219 69.6774 22.372V24.5274H66.3666V22.1501C66.3666 20.5653 65.6662 19.963 64.552 19.963C63.4377 19.963 62.7374 20.5653 62.7374 22.1501V34.1315C62.7374 35.7164 63.4377 36.2869 64.552 36.2869C65.6662 36.2869 66.3666 35.7164 66.3666 34.1315V30.0426H64.7748V26.8729Z",
    fill: "white"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M45.657 17.0469C49.2862 17.0469 50.8462 18.7269 50.8462 22.1501V22.9426C50.8462 25.2247 50.1458 26.6828 48.5859 27.4118C50.4642 28.1408 51.1964 29.8208 51.1964 32.1663V33.9731C51.1964 37.3963 49.3818 39.2347 45.8799 39.2347H40.3724V17.0469H45.657ZM43.8742 20.2166V26.0805H45.2432C46.5484 26.0805 47.3443 25.51 47.3443 23.735V22.4988C47.3443 20.914 46.8031 20.2166 45.5615 20.2166H43.8742ZM43.8742 29.2502V36.0651H45.8799C47.0578 36.0651 47.6945 35.5262 47.6945 33.878V31.9445C47.6945 29.8842 47.0259 29.2502 45.4342 29.2502H43.8742Z",
    fill: "white"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M38.1048 39.2347H34.5711L33.9663 35.2092H29.6685L29.0636 39.2347H25.8483L29.4138 17.0469H34.5393L38.1048 39.2347ZM30.1142 32.198H33.4887L31.8015 20.9773L30.1142 32.198Z",
    fill: "white"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3469 17.0469H18.8488V36.0651H24.611V39.2347H15.3469V17.0469Z",
    fill: "white"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 45,
    width: 148,
    height: 5.16667,
    fill: "#99B2C4"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 53.6111,
    width: 123.837,
    height: 5.16667,
    fill: "#99B2C4"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 62.2222,
    width: 148,
    height: 5.16667,
    fill: "#99B2C4"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 70.8333,
    width: 66.449,
    height: 5.16667,
    fill: "#99B2C4"
  }))), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 2.5,
    y: 2.5,
    width: 173,
    height: 225,
    rx: 2.5,
    stroke: "white",
    strokeWidth: 5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_676_244817"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 178,
    height: 230,
    rx: 5,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOsmosisPoster);
export default __webpack_public_path__ + "static/media/osmosis_poster.35b8988110cb23610f8badb0b7a6c481.svg";
export { ForwardRef as ReactComponent };